/* eslint-disable */

import React,{Component} from 'react';
import SendDropdown from '../Sending-Out/sendDropdown';
import Header from '../Headers';
import url from '../../config/url';

// import Tables from '../Tables';
import SendoutTable from '../Sending-Out/sendOutTable';
import axios from 'axios';
import callMe from '../callApi';
import Singleton from '../../sock';
import  generateBatch  from '../../CommonFunc';
import DisplayError from '../../DisplayError';
import fetchBookNo from '../fetchCode';
import LoaderComponent from '../cAjaxLoader';
import { ToastContainer } from 'react-toastr';

import Select from 'react-select';
import 'react-select/dist/react-select.css';
// var url = ""
var tableBody = [];
var dropdownData = [];
var bookDropdownData = [];
var books = [];
var batchTypeId = 0;
var bookno = [];
var branchSelected = {};
var i = 0;

const myStyle = {
    marginTop:30,
    rows: 10,
}
Array.prototype.contains = function(v) {
    for(var i = 0; i < this.length; i++) {
        if(this[i] === v) return true;
    }
    return false;
};

Array.prototype.unique = function() {
    var arr = [];
    for(var i = 0; i < this.length; i++) {
        if(!arr.includes(this[i])) {
            arr.push(this[i]);
        }
    }
    return arr; 
}
const theaders = ['Book Number','Title','Title Id','Ibt Id', 'Ibt Status','Message'] ;
const mHeaders = ['number','titleName','titleId','ibtId','ibtStatus','message'];//edit it according to json data

class Fulfillment extends Component{
    constructor(props){
        super(props);
        this.state = {
            batchNumber:0,
            bookno:'',
            reset:false,
            errorDesc:'',
            errorVisible:false,
            startListening:false,
            tData:{},
            resetTableBody:false,
            showLoader:false,
            shouldUpdate:false, //new,
            branches:[],
            bookBranches:[],
            branchSelected:'',
            bookBranchSelected:'',
            disableProcess:true,
            disableStop:true,
            disableStart:true,
        }
        this.handleGenerateClick = this.handleGenerateClick.bind(this);
        this.handleStart = this.handleStart.bind(this);
        this.handleStop = this.handleStop.bind(this);
        this.handleProcess = this.handleProcess.bind(this);
        this.handleDDChange = this.handleDDChange.bind(this);
        this.handleBookBranchChange = this.handleBookBranchChange.bind(this);
        // sessionStorage.setItem('hi','hi');
    }

    componentWillMount(){
        // console.log('sendout will mount connection will begin');
        
        this.sock = Singleton.getInstance();
        console.log(this.sock);
    }

    componentDidMount(){
        // console.log('sendout did mount, receive msg here');
        
        axios.get(url + 'generateBatchMetadata')
            .then(res => {
                var ibtBatchTypes = res.data.successObject.ibtBatchTypes;
                for (let i = 0; i < ibtBatchTypes.length; i++) {

                    if (ibtBatchTypes[i].name === 'FULLFILL') {
                        batchTypeId = ibtBatchTypes[i].id;
                    }
                }
                this.setState({showLoader:false})
            }).catch(err => {
                console.log(err);
                this.setState({showLoader:false})
            })
        this.sock.onmessage = msg =>{
            //for java
            if(typeof(msg.data) === 'string'){
                this.fetchCode(msg.data);
            }
            else{
                FileReader.prototype.that = this;
                var reader = new FileReader();
                reader.onload = function() {
                    reader.__proto__.that.fetchCode(reader.result)
                }
                reader.readAsText(msg.data)
           }
        };

        this.sock.onerror = (err) => {
            console.log(err);
            this.refs.container.error("Could not connect to kiosk. Please check your connection and refresh");
            
        }

        this.sock.onclose = (evt) =>{
            console.log(evt);
        }
        if(dropdownData.length === 0){

            axios.get(url + 'getWareHousesForCityByBranchKiosk?branchId='+ sessionStorage.getItem('at')).then(response=>{
                if(response.data.status){
                    var data = response.data.successObject;
                    data.forEach(element => {
                        var obj = {value:element.id,label:element.id  + '-'+element.branchName}
                        dropdownData.push(obj);
                    });
                    this.setState({branches:dropdownData})
                }
            }).catch(err =>{
                console.log(err)
            })
        }    
        if(bookDropdownData.length === 0){

            axios.get(url + 'getAllActiveBranchesKiosk').then(response=>{
                if(response.data.status){
                    var data = response.data.successObject;
                    data.forEach(element => {
                        var obj = {value:element.id,label:element.id  + '-'+element.branchName}
                        bookDropdownData.push(obj);
                    });
                    this.setState({bookBranches:bookDropdownData})
                }
            }).catch(err =>{
                console.log(err)
            })
        }
    }
    componentWillUnmount(){
        bookno=[];
        // console.log('sendout unmount connection will be closed now');
        Singleton.closeSocket(this.sock);
        
    }

    handleDDChange(value){
        // console.log('value is ',value)
        this.setState({branchSelected:value})
        
    }

    handleBookBranchChange(value){
        this.setState({bookBranchSelected:value,disableStart:false})

    }

    /******************* Calling generate batch api ************************* */

    handleGenerateClick(e){
        // console.log("generate cliclk "+ batchTypeID);
        generateBatch(batchTypeId).then(res => {
            if(res.error){
                this.refs.container.error(res.errorDesc);
                // this.setState({errorVisible:true, errorDesc:res.errorDesc})
            }
            else{
                this.setState({batchNumber:res.batchNumber})
            }
        }).catch(err => {console.log(err)})
    }

    /************** start fetching bookno from kiosk *********** */
    handleStart(){
        this.setState({startListening:true,disableStop:false,disableStart:true});
        // this.fetchCode('hi')
    }

    handleProcess(){
        bookno = [];
        this.setState({disableProcess:true,showLoader:true});
        var dataToPost  = [];
        var createdBy = sessionStorage.getItem('by')
        var branch = sessionStorage.getItem('at')
        var selected_branch = this.state.branchSelected
        var selected_book_branch = this.state.bookBranchSelected
        var table = document.getElementById('myTable');
        for (var r = 1, n = table.rows.length; r < n; r++) {
            for (var c = 0, m = table.rows[r].cells.length; c < m; c++) {
                // alert(table.rows[r].cells[c].innerHTML);
                table.rows[r].cells[1].innerText  = "hello"
                var ibtId = table.rows[r].cells[3] ? table.rows[r].cells[3].innerHTML: ''

                var cell=
                {
                    "bookNumber":table.rows[r].cells[0].innerHTML,
                    "ibtId":ibtId,
                    "createdAt":branch, 
                    "createdBy":createdBy,
                    "status":"FULFILLED",
                    "fullFilledBranchId":selected_branch.value,
                    "bookBranchId":selected_book_branch.value

                }
            }
            dataToPost.push(cell)

        }
        console.log(dataToPost);
    // axios.defaults.headers.common['X-SECRET-TOKEN'] = 'qwerty'
        axios.post(url + 'fulfillOrdersUtility',dataToPost).then(res=>{
            this.setState({showLoader:false})
            if(res.data.status){
                res.data.successObject.forEach(function (arr) {
                    console.log(arr);
                    for (var i = 1, row; row = table.rows[i]; i++) {
                        for (var j = 0; j < 1; j++) {
                            // console.log("tavle "+row.cells[j+1].innerText);
                            if (row.cells[j].innerText == arr['bookNumber']) 
                            {
                                if(!arr['status']){
                                // console.log("inner text "+row.cells[j + 6].innerText)
                                    row.cells[j + 5].innerText = arr['errorDescription'];
                                    row.cells[j + 5].style.color = "red";

                                }
                                else{
                                    row.cells[j + 5].innerText =arr['successObject'];
                                    row.cells[j + 5].style.color = "green";

                                }
                            }
                            
                        }
                    }
                })
            }else{
                this.refs.container.error(res.data.errorDescription)
            }
        }).catch(err=>{
            this.setState({showLoader:false})
            this.refs.container.error('Something went wrong');

        })
    }


    handleStop(){
        this.setState({startListening:false,disableStart:false,disableProcess:false,disableStop:true});

    }

    getBatchType(batchTypeId){
        batchTypeID = batchTypeId; //this will be used to call generateBatchNumber api
    
    }

    getDropdownOnChangeData(value){
        branchSelected = {}
        console.log('value of change is ',value)
        branchSelected = value;
    }

    //calling the sort api 
    fetchCode(value)
    {
        if(books.includes(value)){
            return;
        }
        books.push(value)
        var obj = {
            value:value,
            bookno:bookno,
            start:this.state.startListening,
            callingFrom:"sort"
        };
        fetchBookNo(obj).then(res => {
            console.log(res);
            if(res.error){
                this.refs.container.error(res.data)  
            }
            else{
                this.setState({tData:res.data})
            }
            bookno = res.bookno;
        }).catch(err => {
            console.log(err);
            this.refs.container.error('Something Went Wrong!!')
            
            return;
        });
        

    }



    render(){
        const { branches,bookBranches } = this.state;

        return(
            <React.Fragment>
                <LoaderComponent showLoader = {this.state.showLoader}>
                <ToastContainer 
                    ref = "container"    
                    className="toast-top-right"
                />
                <Header hname = "Fulfill"/>

                <DisplayError 
                    errorVisible = {this.state.errorVisible}
                    errorDesc = {this.state.errorDesc}
                />
                <div className="row" style = {{marginTop:30}}>
                    <div className="col-lg-3">
                        <Select style = {{marginBottom:5}}
                            name="target-branch"
                            value = {this.state.branchSelected}
                            clearable={false}
                            options={branches}
                            onChange = {this.handleDDChange}                            
                            placeholder='Select Fulfilled Via Branch..'
                            
                        />
                    </div>
                    <div className="col-lg-3">
                        <Select style = {{marginBottom:5}}
                            name="target-branch"
                            value = {this.state.bookBranchSelected}
                            clearable={false}
                            options={bookBranches}
                            onChange = {this.handleBookBranchChange}                            
                            placeholder='Select Book Branch..'
                            
                        />
                    </div>
                    <div  className = "col-sm-6">
                        <button style = {{marginRight:10}}className = "btn" onClick = {this.handleStart} disabled={this.state.disableStart}>Start</button>
                        <button style = {{marginRight:10}}className = "btn" onClick = {this.handleStop} disabled={this.state.disableStop}  >Stop</button>
                        <button style = {{marginRight:10}}className = "btn" onClick = {this.handleProcess} disabled={this.state.disableProcess}>Process</button>
                    </div> 

                </div>
                <div className = "row">
                    <div className="col-lg-4" style = {{margin: 30}}>
                
                        <button className = "btn" 
                            onClick = {this.handleGenerateClick}>Create Batch</button>
                
                        <input type="text" readOnly 
                        style = {{marginLeft:10,width:50}} value={this.state.batchNumber}/>
                        
                    </div>

                    <div className = "col-lg-8"></div>
                </div>

                <div className = "row">
                    <div className = "col-lg-12">
                        <SendoutTable 
                            mHeaders = {mHeaders} 
                            displayCount = {this.input} 
                           // fetchTableBody = {this.fetchTableBody.bind(this)}
                            headers = {theaders} 
                            body = {this.state.tData}
                            resetTable = {this.state.resetTableBody} 
                            //shouldUpdate = {this.state.shouldUpdate}
                        />
                    </div>  
                
                </div>
                </LoaderComponent>
            </React.Fragment>
        )
    }
}

export default Fulfillment;


// WEBPACK FOOTER //
// ./src/Components/Fulfill/fulfillment.js